import React from "react";
import { Table, Empty } from "antd";

interface CsvTableProps {
    data: any[];
}

const UploadList: React.FC<CsvTableProps> = ({ data }) => {
    const columns = Object.keys(data[0] || {}).map((key) => ({
        title: key?.replace(/_/g, ' ')?.toUpperCase(),
        dataIndex: key,
        key: key,
    }));

    return (
        <div className="responsivetable">
            {data.length > 0 ? (
                <Table
                    dataSource={data}
                    columns={columns}
                    rowKey={(record) => JSON.stringify(record)}
                    pagination={{
                        total: data.length,
                        showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
                        pageSize: 10, // You can set the default page size here
                    }}
                />
            ) : (
                <Empty description="No data available" />
            )}
        </div>
    );
};

export default UploadList;